__turbopack_context__.v({
  "actionBar": "recipe-detail-client-module__wloDpG__actionBar",
  "article": "recipe-detail-client-module__wloDpG__article",
  "fabScrim": "recipe-detail-client-module__wloDpG__fabScrim",
  "fabServings": "recipe-detail-client-module__wloDpG__fabServings",
  "fabSheet": "recipe-detail-client-module__wloDpG__fabSheet",
  "fabSheetActions": "recipe-detail-client-module__wloDpG__fabSheetActions",
  "fabSheetClose": "recipe-detail-client-module__wloDpG__fabSheetClose",
  "fabSheetHandle": "recipe-detail-client-module__wloDpG__fabSheetHandle",
  "fabSheetHeader": "recipe-detail-client-module__wloDpG__fabSheetHeader",
  "fabSheetTitle": "recipe-detail-client-module__wloDpG__fabSheetTitle",
  "generateVariantBtn": "recipe-detail-client-module__wloDpG__generateVariantBtn",
  "generateVariantBtns": "recipe-detail-client-module__wloDpG__generateVariantBtns",
  "generateVariants": "recipe-detail-client-module__wloDpG__generateVariants",
  "generateVariantsLabel": "recipe-detail-client-module__wloDpG__generateVariantsLabel",
  "guideCta": "recipe-detail-client-module__wloDpG__guideCta",
  "guideError": "recipe-detail-client-module__wloDpG__guideError",
  "guideHint": "recipe-detail-client-module__wloDpG__guideHint",
  "guideLoading": "recipe-detail-client-module__wloDpG__guideLoading",
  "guideLoadingIcon": "recipe-detail-client-module__wloDpG__guideLoadingIcon",
  "heroOverlayBtn": "recipe-detail-client-module__wloDpG__heroOverlayBtn",
  "kcalSwitch": "recipe-detail-client-module__wloDpG__kcalSwitch",
  "lineageBand": "recipe-detail-client-module__wloDpG__lineageBand",
  "lineageGrid": "recipe-detail-client-module__wloDpG__lineageGrid",
  "lineageLabel": "recipe-detail-client-module__wloDpG__lineageLabel",
  "main": "recipe-detail-client-module__wloDpG__main",
  "mobileTab": "recipe-detail-client-module__wloDpG__mobileTab",
  "mobileTabActive": "recipe-detail-client-module__wloDpG__mobileTabActive",
  "mobileTabs": "recipe-detail-client-module__wloDpG__mobileTabs",
  "noteFadeUp": "recipe-detail-client-module__wloDpG__noteFadeUp",
  "nutritionSection": "recipe-detail-client-module__wloDpG__nutritionSection",
  "panel": "recipe-detail-client-module__wloDpG__panel",
  "scrimIn": "recipe-detail-client-module__wloDpG__scrimIn",
  "sectionHeader": "recipe-detail-client-module__wloDpG__sectionHeader",
  "sectionTitle": "recipe-detail-client-module__wloDpG__sectionTitle",
  "selectorBand": "recipe-detail-client-module__wloDpG__selectorBand",
  "sheetIn": "recipe-detail-client-module__wloDpG__sheetIn",
  "sidebar": "recipe-detail-client-module__wloDpG__sidebar",
  "signInGate": "recipe-detail-client-module__wloDpG__signInGate",
  "signInGateText": "recipe-detail-client-module__wloDpG__signInGateText",
  "techniqueInsight": "recipe-detail-client-module__wloDpG__techniqueInsight",
  "twoCol": "recipe-detail-client-module__wloDpG__twoCol",
  "variantGenError": "recipe-detail-client-module__wloDpG__variantGenError",
  "variantNote": "recipe-detail-client-module__wloDpG__variantNote",
  "variantSteerDescription": "recipe-detail-client-module__wloDpG__variantSteerDescription",
});
